import styled from 'styled-components';

export const PageContainer = styled.div`
  color: ${props => props.theme.colors.textQuote()};
  background-color: ${props => props.theme.colors.textQuote(0.03)};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0 30px;

  > h2 {
    margin: 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    padding: 60px 20px 70px;
  }
`;

export const FieldsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    flex-direction: row;
  }

  > div + div {
    margin-top: 10px;

    @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
      margin-left: 20px;
      margin-top: 0;
    }
  }

  > div > div {
    @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
      margin-top: 0;
    }
  }

  div.static {
    @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
      margin-top: 39px;
    }
  }
`;

export const CardsContainer = styled.div`
  margin-top: 60px;
  max-width: 700px;
  padding: 0 20px 20px;

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
    margin-top: 40px;
    padding: 0 0 20px;
  }
`;

export const CardsInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BulletsContainer = styled.div`
  > div + div {
    margin-left: 4px;
  }
`;

export const Bullet = styled.div`
  border-radius: 50%;
  background-color: ${props => props.theme.colors.textQuote(0.7)};
  width: 4px;
`;
